import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useCompetitionStore } from '../../stores/competitionStore';
import { subdomainParamKey } from './injectSubdomainAsRouteParam';

export default async function fetchCompetition(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void>
{
    await useCompetitionStore().fetchCompetition({subdomain: to.params[subdomainParamKey] as string})
    return next();
}